module.exports = __webpack_public_path__ + "files/5cb7192b3402e1d769c7fbb426c976df.png";